import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LanguageService } from './language.service';
import { AuthService } from './shared/provider-service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bogo-plus';
  isHiddenHeader = false;
  constructor(private languageServ: LanguageService, private router: Router, private authService: AuthService) {
    this.languageServ.initLanguageServices()
    this.router.events.subscribe(event => {
      window.scrollTo(0, 0)
      this.authService.token_beh.subscribe((val) => {
        let user_type = localStorage.getItem('user_type');
        if (val) {
          if (event instanceof NavigationEnd) {

            if (event.url == '/landing') {
              this.isHiddenHeader = true;
            } else {
              this.isHiddenHeader = false;
            }
            if (event.url == '/') {
              if (user_type === 'merchant') {
                event.urlAfterRedirects = '/merchant/home';
                event.url = '/merchant/home';
                this.router.navigateByUrl('/merchant/home')
              } else if (user_type === 'client') {
                event.urlAfterRedirects = '/user/home';
                event.url = '/user/home';
                this.router.navigateByUrl('/user/home')
              }

              this.isHiddenHeader = false;

            }
          }
        }
      })

    });
  }
}
